/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FieldCheckboxCreateV1Dto = {
  /**
   * Height of the field in pixels
   */
  height?: number;
  /**
   * Name of the field
   */
  name?: string | null;
  /**
   * Page number the field is located on
   */
  page: number;
  /**
   * Type of the field
   */
  type: FieldCheckboxCreateV1Dto.type;
  /**
   * Width of the field in pixels
   */
  width?: number;
  /**
   * X coordinate of the field on the page in pixels
   */
  x: number;
  /**
   * X coordinate of the field on the page in pixels
   */
  y: number;
  /**
   * UUID of the document the field belongs to
   */
  document_id?: string;
  /**
   * Whether the checkbox is checked
   */
  checked: boolean;
  /**
   * Whether the checkbox is optional
   */
  optional: boolean;
  /**
   * Size of the checkbox in pixels
   */
  size: number;
};
export namespace FieldCheckboxCreateV1Dto {
  /**
   * Type of the field
   */
  export enum type {
    CHECKBOX = 'checkbox',
    MENTION = 'mention',
    RADIO_GROUP = 'radio_group',
    SIGNATURE = 'signature',
    TEXT = 'text',
  }
}
